import { render, staticRenderFns } from "./Cb4xPxfMention.vue?vue&type=template&id=3cd697f8"
import script from "./Cb4xPxfMention.vue?vue&type=script&lang=js"
export * from "./Cb4xPxfMention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports